var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 73,
    viewBox: "0 0 85 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_313_16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6377 0V60H67.6377V28.5889L24.041 72.1855H0L55.1855 17H24.6377V0H84.6377Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6377 0H86.6377V-2H84.6377V0ZM84.6377 60V62H86.6377V60H84.6377ZM67.6377 60H65.6377V62H67.6377V60ZM67.6377 28.5889H69.6377V23.7604L66.2235 27.1747L67.6377 28.5889ZM24.041 72.1855V74.1855H24.8694L25.4552 73.5998L24.041 72.1855ZM0 72.1855L-1.41421 70.7713L-4.82843 74.1855H0V72.1855ZM55.1855 17L56.5998 18.4142L60.014 15H55.1855V17ZM24.6377 17H22.6377V19H24.6377V17ZM24.6377 0V-2H22.6377V0H24.6377ZM84.6377 0H82.6377V60H84.6377H86.6377V0H84.6377ZM84.6377 60V58H67.6377V60V62H84.6377V60ZM67.6377 60H69.6377V28.5889H67.6377H65.6377V60H67.6377ZM67.6377 28.5889L66.2235 27.1747L22.6268 70.7713L24.041 72.1855L25.4552 73.5998L69.0519 30.0031L67.6377 28.5889ZM24.041 72.1855V70.1855H0V72.1855V74.1855H24.041V72.1855ZM0 72.1855L1.41421 73.5998L56.5998 18.4142L55.1855 17L53.7713 15.5858L-1.41421 70.7713L0 72.1855ZM55.1855 17V15H24.6377V17V19H55.1855V17ZM24.6377 17H26.6377V0H24.6377H22.6377V17H24.6377ZM24.6377 0V2H84.6377V0V-2H24.6377V0Z",
    fill: "black",
    mask: "url(#path-1-inside-1_313_16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8b18ad40c717f2dea4c7d6207b886d76.svg";
export { ForwardRef as ReactComponent };